<template>
  <div class="notification-section">
    <!-- WEB Device -->
    <div class="notification-device">
      <!-- Heading -->
      <div class="notification-header">
        <h2 class="notification-title">
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 14.1418 5.85778 17.4997 9.99992 17.4997C14.1421 17.4997 17.4999 14.1418 17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967ZM0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.833252 9.99967C0.833252 9.53944 1.20635 9.16634 1.66659 9.16634H18.3333C18.7935 9.16634 19.1666 9.53944 19.1666 9.99967C19.1666 10.4599 18.7935 10.833 18.3333 10.833H1.66659C1.20635 10.833 0.833252 10.4599 0.833252 9.99967Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.50011 9.99967C7.55722 12.562 8.43846 15.029 9.99992 17.0407C11.5614 15.029 12.4426 12.562 12.4997 9.99967C12.4426 7.43731 11.5614 4.97038 9.99992 2.95867C8.43846 4.97038 7.55722 7.43731 7.50011 9.99967ZM9.99992 1.66634L9.38463 1.10432C7.16399 3.53543 5.90201 6.69039 5.83343 9.98232C5.83319 9.99389 5.83319 10.0055 5.83343 10.017C5.90201 13.309 7.16399 16.4639 9.38463 18.895C9.54251 19.0679 9.76582 19.1663 9.99992 19.1663C10.234 19.1663 10.4573 19.0679 10.6152 18.895C12.8358 16.4639 14.0978 13.309 14.1664 10.017C14.1666 10.0055 14.1666 9.99389 14.1664 9.98232C14.0978 6.69039 12.8358 3.53543 10.6152 1.10432L9.99992 1.66634Z"
                fill="#B3C2CB"
              />
            </svg>
          </span>
          MyApps Settings
        </h2>
      </div>
      <!-- Heading  -->
      <div class="notifications">
        <Notification :list="myApps" @settingsUpdated="updateMyAppSettings" />
      </div>
    </div>
    <!-- WEB Device -->
    <div v-if="false" class="notification-device">
      <!-- Heading -->
      <div class="notification-header">
        <h2 class="notification-title">
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 14.1418 5.85778 17.4997 9.99992 17.4997C14.1421 17.4997 17.4999 14.1418 17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967ZM0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.833252 9.99967C0.833252 9.53944 1.20635 9.16634 1.66659 9.16634H18.3333C18.7935 9.16634 19.1666 9.53944 19.1666 9.99967C19.1666 10.4599 18.7935 10.833 18.3333 10.833H1.66659C1.20635 10.833 0.833252 10.4599 0.833252 9.99967Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.50011 9.99967C7.55722 12.562 8.43846 15.029 9.99992 17.0407C11.5614 15.029 12.4426 12.562 12.4997 9.99967C12.4426 7.43731 11.5614 4.97038 9.99992 2.95867C8.43846 4.97038 7.55722 7.43731 7.50011 9.99967ZM9.99992 1.66634L9.38463 1.10432C7.16399 3.53543 5.90201 6.69039 5.83343 9.98232C5.83319 9.99389 5.83319 10.0055 5.83343 10.017C5.90201 13.309 7.16399 16.4639 9.38463 18.895C9.54251 19.0679 9.76582 19.1663 9.99992 19.1663C10.234 19.1663 10.4573 19.0679 10.6152 18.895C12.8358 16.4639 14.0978 13.309 14.1664 10.017C14.1666 10.0055 14.1666 9.99389 14.1664 9.98232C14.0978 6.69039 12.8358 3.53543 10.6152 1.10432L9.99992 1.66634Z"
                fill="#B3C2CB"
              />
            </svg>
          </span>
          WEB BROWSER
        </h2>
        <h3 class="notification-des">
          <span @click="toggleWeb">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.668 10C16.668 7.22656 14.9727 4.85156 12.5664 3.84766L11.9258 5.38672C13.7305 6.14062 15 7.92187 15 10C15 12.082 13.7305 13.8594 11.9219 14.6133L12.5625 16.1523C14.9727 15.1484 16.668 12.7734 16.668 10ZM13.332 10C13.332 8.61328 12.4844 7.42578 11.2812 6.92578L10.6406 8.46484C11.2422 8.71484 11.6641 9.30859 11.6641 10.0039C11.6641 10.6953 11.2422 11.2891 10.6406 11.543L11.2812 13.082C12.4844 12.5742 13.332 11.3867 13.332 10ZM13.8477 0.769531L13.2031 2.30859C16.2148 3.5625 18.332 6.53125 18.332 10C18.332 13.4648 16.2148 16.4375 13.2031 17.6914L13.8438 19.2305C17.4609 17.7227 20 14.1602 20 10C20 5.83984 17.4609 2.27734 13.8477 0.769531ZM0 5.83203V14.1641H4.52606L9.36697 18.408V1.59204L4.52606 5.83203H0Z"
                :fill="[webActive ? 'var(--theme-color)' : '#ddd']"
              />
            </svg>
          </span>
          Play Sound on Web Browser
        </h3>
      </div>
      <!-- Heading  -->
      <div class="notifications">
        <Notification
          :list="webNotifications"
          @settingsUpdated="updateWebNotifications"
        />
      </div>
    </div>
    <!-- Device -->
    <!-- Mobile Device -->
    <div v-if="false" class="notification-device">
      <!-- Heading -->
      <div class="notification-header">
        <h2 class="notification-title">
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.1666 19.1663H5.83325C4.41659 19.1663 3.33325 18.083 3.33325 16.6663V3.33301C3.33325 1.91634 4.41659 0.833008 5.83325 0.833008H14.1666C15.5833 0.833008 16.6666 1.91634 16.6666 3.33301V16.6663C16.6666 18.083 15.5833 19.1663 14.1666 19.1663ZM5.83325 2.49967C5.33325 2.49967 4.99992 2.83301 4.99992 3.33301V16.6663C4.99992 17.1663 5.33325 17.4997 5.83325 17.4997H14.1666C14.6666 17.4997 14.9999 17.1663 14.9999 16.6663V3.33301C14.9999 2.83301 14.6666 2.49967 14.1666 2.49967H5.83325Z"
                fill="#B3C2CB"
              />
              <path
                d="M9.99992 15.833C9.91658 15.833 9.74992 15.833 9.66658 15.7497C9.58325 15.7497 9.49992 15.6663 9.41658 15.583C9.24992 15.4163 9.16658 15.2497 9.16658 14.9997C9.16658 14.9163 9.16658 14.7497 9.24992 14.6663C9.33325 14.583 9.33325 14.4997 9.41658 14.4163C9.74992 14.083 10.2499 14.083 10.5833 14.4163C10.7499 14.583 10.8333 14.833 10.8333 14.9997C10.8333 15.2497 10.7499 15.4163 10.5833 15.583C10.4166 15.7497 10.2499 15.833 9.99992 15.833Z"
                fill="#B3C2CB"
              />
            </svg>
          </span>
          MOBILE PUSH
        </h2>
        <h3 class="notification-des">
          <span @click="toggleMobile">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.668 10C16.668 7.22656 14.9727 4.85156 12.5664 3.84766L11.9258 5.38672C13.7305 6.14062 15 7.92187 15 10C15 12.082 13.7305 13.8594 11.9219 14.6133L12.5625 16.1523C14.9727 15.1484 16.668 12.7734 16.668 10ZM13.332 10C13.332 8.61328 12.4844 7.42578 11.2812 6.92578L10.6406 8.46484C11.2422 8.71484 11.6641 9.30859 11.6641 10.0039C11.6641 10.6953 11.2422 11.2891 10.6406 11.543L11.2812 13.082C12.4844 12.5742 13.332 11.3867 13.332 10ZM13.8477 0.769531L13.2031 2.30859C16.2148 3.5625 18.332 6.53125 18.332 10C18.332 13.4648 16.2148 16.4375 13.2031 17.6914L13.8438 19.2305C17.4609 17.7227 20 14.1602 20 10C20 5.83984 17.4609 2.27734 13.8477 0.769531ZM0 5.83203V14.1641H4.52606L9.36697 18.408V1.59204L4.52606 5.83203H0Z"
                :fill="[mobileActive ? 'var(--theme-color)' : '#ddd']"
              />
            </svg>
          </span>
          Play Sound on Mobile Push
        </h3>
      </div>
      <!-- Heading  -->
      <div class="notifications">
        <Notification
          :list="mobileNotifications"
          @settingsUpdated="updateMobileNotifications"
        ></Notification>
      </div>
    </div>
    <!-- Device -->
    <!-- Device -->
    <div v-if="false" class="notification-device">
      <!-- Heading -->
      <div class="notification-header">
        <h2 class="notification-title">
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.33325 4.16667C2.87682 4.16667 2.49992 4.54357 2.49992 5V15C2.49992 15.4564 2.87682 15.8333 3.33325 15.8333H16.6666C17.123 15.8333 17.4999 15.4564 17.4999 15V5C17.4999 4.54357 17.123 4.16667 16.6666 4.16667H3.33325ZM0.833252 5C0.833252 3.6231 1.95635 2.5 3.33325 2.5H16.6666C18.0435 2.5 19.1666 3.6231 19.1666 5V15C19.1666 16.3769 18.0435 17.5 16.6666 17.5H3.33325C1.95635 17.5 0.833252 16.3769 0.833252 15V5Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.983964 4.52251C1.24789 4.14547 1.7675 4.05378 2.14454 4.3177L9.99999 9.81652L17.8554 4.3177C18.2325 4.05378 18.7521 4.14547 19.016 4.52251C19.2799 4.89955 19.1882 5.41916 18.8112 5.68309L10.4779 11.5164C10.1909 11.7173 9.80904 11.7173 9.52211 11.5164L1.18877 5.68309C0.81173 5.41916 0.720035 4.89955 0.983964 4.52251Z"
                fill="#B3C2CB"
              />
            </svg>
          </span>
          EMAIL
        </h2>
      </div>
      <!-- Heading  -->
      <div class="notifications">
        <Notification
          :list="emailNotifications"
          @settingsUpdated="updateEmailNotifications"
        ></Notification>
      </div>
    </div>
    <!-- Device -->
    <div class="row">
      <div class="col-md-12">
        <div class="foot">
          <b-button
            variant="primary btn-round-fill"
            @click.prevent="saveSettings"
            >Save Changes</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notification from "./notification/index";
export default {
  name: "Me_Settings",
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Notification
  },
  methods: {
    toggleMobile() {
      this.mobileActive = !this.mobileActive;
    },
    toggleWeb() {
      this.webActive = !this.webActive;
    },
    updateMyAppSettings(settings) {
      this.myApps = settings;
    },
    updateWebNotifications(settings) {
      this.webNotifications = settings;
    },
    updateMobileNotifications(settings) {
      this.mobileNotifications = settings;
    },
    updateEmailNotifications(settings) {
      this.emailNotifications = settings;
    },
    saveSettings() {
      let dataToUpdate = {
        settings: {
          myApps: {
            //@TODO- I don't necessarily like doing it this way- but just here to fix atm
            isTapToClose: this.myApps[0].value,
            isDisplayActivity: this.myApps[1].value,
            isDisplaySettings: this.myApps[2].value,
            isOptInForAnalytics: this.myApps[3].value,
            isOptInForResearch: this.myApps[4].value
          }
        },
        force: true
      };
      /* Save for a later version         settingsV5: {
          notifications: {
            web: {
              sound: this.webActive,
              all: this.webNotifications[0].value,
              join: this.webNotifications[1].value
            },
            mobile: {
              sound: this.mobileActive,
              all: this.mobileNotifications[0].value,
              join: this.mobileNotifications[1].value
            },
            email: {
              newfocusdetail: this.emailNotifications[0].value,
              join: this.emailNotifications[1].value,
              weeklyreport: this.emailNotifications[2].value,
              monthlyreport: this.emailNotifications[3].value,
              tips: this.emailNotifications[4].value
            }
          }
        }, */
      console.log(dataToUpdate);
      this.$store
        .dispatch("user/updateProfile", dataToUpdate)
        .then(res => {
          if (res) {
            this.$store.dispatch("user/getProfile").then(() => {
              this.$store.dispatch("user/showNotification", {
                title: "Successfully Update",
                description: "You have successfully updated your settings.",
                variant: "success"
              });
            });
          }
        })
        .catch(rej => {
          if (rej) {
            this.$store.dispatch("user/showNotification", {
              title: "We were not able to save your settings",
              description: "Oops!!! We are looking into the issue",
              variant: "danger"
            });
          }
        });
    }
  },
  data() {
    return {
      myApps: [
        {
          name: "Lock 'Tap To Close'",
          text: ` Locks the ability to close the app by tapping outside area.`,
          value:
              this.profile.settings &&
              this.profile.settings.myApps &&
              this.profile.settings.myApps.isTapToClose
                  ? this.profile.settings.myApps.isTapToClose
                  : false
        },
        {
          name: "Display Activity",
          text: ` Displays the tab for the Insights/Activity of each app`,
          value:
              this.profile.settings &&
              this.profile.settings.myApps &&
              this.profile.settings.myApps.isDisplayActivity
                  ? this.profile.settings.myApps.isDisplayActivity
                  : false
        },
        {
          name: "Display Settings",
          text: ` Displays the tab for the settings of each app`,
          value:
              this.profile.settings &&
              this.profile.settings.myApps &&
              this.profile.settings.myApps.isDisplaySettings
                  ? this.profile.settings.myApps.isDisplaySettings
                  : false
        },
        {
          name: "Support Analytics",
          text: `Help us improve the System by Opting in to Data Collection for MyApp Usage`,
          value:
              this.profile.settings &&
              this.profile.settings.myApps &&
              this.profile.settings.myApps.isOptInForAnalytics
                  ? this.profile.settings.myApps.isOptInForAnalytics
                  : false
        },
        {
          name: "Support Data Research Studies",
          text: `Help end or reduce Dementia by Opting your anonymized data into approved Research Labs`,
          value:
              this.profile.settings &&
              this.profile.settings.myApps &&
              this.profile.settings.myApps.isOptInForResearch
                  ? this.profile.settings.myApps.isOptInForResearch
                  : false
        }
      ],
      webNotifications: [
        {
          name: "All Activities",
          text: ` Receive all notifications that we send out.`,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.web &&
              this.profile.settings.notifications.web.all
                  ? this.profile.settings.notifications.web.all
                  : false
        },
        {
          name: "Join Requests",
          text: `  Be notified when some one asks you to join their journey.`,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.web &&
              this.profile.settings.notifications.web.join
                  ? this.profile.settings.notifications.web.join
                  : false
        }
      ],
      mobileNotifications: [
        {
          name: "All Activities",
          text: `  Receive all notifications that we send out.`,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.mobile &&
              this.profile.settings.notifications.mobile.all
                  ? this.profile.settings.notifications.mobile.all
                  : false
        },
        {
          name: "Join Requests",
          text: `  Be notified when some one asks you to join their journey.`,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.mobile &&
              this.profile.settings.notifications.mobile.join
                  ? this.profile.settings.notifications.mobile.join
                  : false
        }
      ],
      emailNotifications: [
        {
          name: "New Focused Journey Details",
          text: `  Send you details on your newly created focus`,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email &&
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email.newfocusdetail
                  ? this.profile.settings.notifications.email.newfocusdetail
                  : false
        },
        {
          name: "Join Requests",
          text: `  Emailed your Join Request.`,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email &&
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email.join
                  ? this.profile.settings.notifications.email.join
                  : false
        },
        {
          name: "Weekly Reports",
          text: ``,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email &&
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email.weeklyreport
                  ? this.profile.settings.notifications.email.weeklyreport
                  : false
        },
        {
          name: "Monthly Summaries",
          text: ``,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email &&
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email.monthlyreport
                  ? this.profile.settings.notifications.email.monthlyreport
                  : false
        },
        {
          name: "Helpful Tips",
          text: ``,
          value:
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email &&
              this.profile.settings &&
              this.profile.settings.notifications &&
              this.profile.settings.notifications.email.tips
                  ? this.profile.settings.notifications.email.tips
                  : false
        }
      ],
      webActive:
          this.profile.settings &&
          this.profile.settings.notifications &&
          this.profile.settings.notifications.web &&
          this.profile.settings.notifications.web.sound
              ? this.profile.settings.notifications.web.sound
              : false,
      mobileActive:
          this.profile.settings &&
          this.profile.settings.notifications &&
          this.profile.settings.notifications.mobile &&
          this.profile.settings.notifications.mobile.sound
              ? this.profile.settings.notifications.mobile.sound
              : false
    };
  }
};
</script>

<style lang="scss" scoped>
.notification-section {
  font-family: "Nunito", sans-serif;
  .notification-device {
    position: relative;
    margin-top: 32px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ddd;
    .notification-header {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      @media (max-width: 500px) {
        flex-direction: column;
      }
      .notification-title {
        font-weight: 600;
        font-size: 14px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #474d52;

        span {
          padding-right: 8px;
        }
      }
      .notification-des {
        span {
          cursor: pointer;
        }
      }
      h3 {
        margin-left: 16px;
        font-weight: 600;
        font-size: 12px;

        display: flex;
        align-items: center;
        color: #474d52;
        span {
          padding-right: 8px;
        }
      }
    }

    .notification {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 16px;

      .notification-content {
        margin-left: 14px;
        cursor: pointer;
        p {
          font-style: normal;
          font-weight: normal;
          font-size: 12px;

          color: #8d99a0;
          margin: 0;
        }
        h6 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;

          display: flex;
          align-items: center;
          color: #474d52;
          @media (max-width: 874px) {
            margin-bottom: 0px;
          }
        }
      }
      .toggler {
        @media (max-width: 874px) {
          margin-bottom: 10px;
          margin-left: 15px;
        }
        position: relative;
        display: inline-block;
        width: 36px;
        height: 17px;
        background-color: #e8ebec;
        border-radius: 24px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      .slider {
        position: absolute;
        content: "";
        height: 23px;
        width: 23px;
        left: -3px;
        bottom: -3px;
        background: #8d99a0;

        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
      }
      .bg {
        background: #dde5fe;
      }
      .btns {
        left: 50%;
        background-color: var(--theme-color);
      }
    }
  }
  .btn-round-fill {
    width: 166px;
    height: 40px;
    margin-top: 24px;
    // margin-bottom: 24px;
    // margin-bottom: 80px;
  }
  .foot {
    // border-top: 1px solid #ddd;
    margin-top: 24px;
    margin-bottom: 80px;
  }
}
</style>
